module.exports = __webpack_public_path__ + "static/img/MH-250x250px-BW.4e28978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/MH-250x250px-BW.png
// module id = 530
// module chunks = 1